<template>
  <pro-layout
    :menus="menus"
    :collapsed="false"
    :mediaQuery="query"
    :isMobile="isMobile"
    :handleMediaQuery="handleMediaQuery"
    :handleCollapse="handleCollapse"
    :logo="logoUrl"
    :i18nRender="i18nRender"
    v-bind="settings"
  >
    <!-- Ads begin
      广告代码 真实项目中请移除
      production remove this Ads
    -->
    <!-- <ads v-if="isProPreviewSite && !collapsed"/> -->
    <!-- Ads end -->

    <!-- <setting-drawer v-show="setting_drawer" :settings="settings" @change="handleSettingChange" /> -->
    <template v-slot:rightContentRender>
      <right-content :top-menu="settings.layout === 'topmenu'" :is-mobile="isMobile" />
    </template>
    <template v-slot:footerRender>
      <!-- <global-footer /> -->
      <span></span>
    </template>
    <router-view />
  </pro-layout>
</template>

<script>
import { SettingDrawer, updateTheme } from '@ant-design-vue/pro-layout'
import { i18nRender } from '@/locales'
import { mapState } from 'vuex'
import { SIDEBAR_TYPE, TOGGLE_MOBILE_TYPE } from '@/store/mutation-types'

import defaultSettings from '@/config/defaultSettings'
import RightContent from '@/components/GlobalHeader/RightContent'
import GlobalFooter from '@/components/GlobalFooter'
import Ads from '@/components/Other/CarbonAds'
// import LogoSvg from '@/assets/logo.svg?inline'
import LogoSvg from '@/assets/ms-icon-70x70.svg?inline'
import { asyncRouterMap } from '@/config/router.config'
import cookie from 'js-cookie'

export default {
  name: 'BasicLayout',
  components: {
    SettingDrawer,
    RightContent,
    GlobalFooter,
    Ads
  },
  data () {
    return {
      // preview.pro.antdv.com only use.
      isProPreviewSite: process.env.VUE_APP_PREVIEW === 'true' && process.env.NODE_ENV !== 'development',
      // end

      // base
      setting_drawer: ((process.env.NODE_ENV === 'development') ? true : false),
      menus: [],
      // 侧栏收起状态
      collapsed: false,
      title: defaultSettings.title,
      settings: {
        // 布局类型
        layout: defaultSettings.layout, // 'sidemenu', 'topmenu'
        // 定宽: true / 流式: false
        contentWidth: defaultSettings.layout === 'sidemenu' ? false : defaultSettings.contentWidth === 'Fixed',
        // 主题 'dark' | 'light'
        theme: defaultSettings.navTheme,
        // 主色调
        primaryColor: defaultSettings.primaryColor,
        fixedHeader: defaultSettings.fixedHeader,
        fixSiderbar: defaultSettings.fixSiderbar,
        colorWeak: defaultSettings.colorWeak,

        hideHintAlert: false,
        hideCopyButton: false
      },
      // 媒体查询
      query: {},

      // 是否手机模式
      isMobile: false
    }
  },
  computed: {
    ...mapState({
      // 动态主路由
      mainMenu: state => state.permission.addRouters
    }),
    userType() {
      return this.$store.getters.loginType
    },
    logoUrl() {
      const userType = this.$store.getters.loginType
      if (userType === 1) {
        return require('@/assets/logo_admin.png')
      } else {
        return require('@/assets/logo_teacher.png')
      }
    }
  },
  watch: {
    'userType': {
      handler() {
        this.changeType(this.userType)
      },
      deep: true
    },
    '$route': {
      handler(el) {
        const hidden = this.$route.name !== 'index'
        const content = document.getElementsByClassName('sidemenu')
        hidden ? content[0].classList.add('hidden') : content[0].classList.remove('hidden')
      },
      deep: true
    }
  },
  created () {
    // const routes = this.mainMenu.find(item => item.path === '/')
    // this.menus = (routes && routes.children) || []
    // const routes = asyncRouterMap.find(item => item.path === '/')
    // this.menus = (routes && routes.children) || []
  },
  mounted () {
    this.changeType(this.userType)
    const userAgent = navigator.userAgent
    if (userAgent.indexOf('Edge') > -1) {
      this.$nextTick(() => {
        this.collapsed = !this.collapsed
        setTimeout(() => {
          this.collapsed = !this.collapsed
        }, 16)
      })
    }

    // first update color
    // TIPS: THEME COLOR HANDLER!! PLEASE CHECK THAT!!
    if (process.env.NODE_ENV !== 'production' || process.env.VUE_APP_PREVIEW === 'true') {
      updateTheme(this.settings.primaryColor)
    }
  },
  methods: {
    i18nRender,
    changeType(userType) {
      const sidemenu = document.getElementsByClassName('ant-layout-sider')
      const content = document.getElementsByClassName('sidemenu')
      if (userType === 1) {
        this.logoUrl = require('@/assets/logo_admin.png')
        this.menus = asyncRouterMap[1].children || []
        // this.$router.addRoutes(asyncRouterMap[1])
        this.$router.push({ path: '/teacher/list' })
        sidemenu[0].classList.add('admin')
        content[0].classList.add('admin')
        sidemenu[0].classList.remove('teacher')
        content[0].classList.remove('teacher')
      } else {
        this.$router.addRoutes(asyncRouterMap)
        this.logoUrl = require('@/assets/logo_teacher.png')
        this.menus = asyncRouterMap[0].children || []
        // this.$router.addRoutes(asyncRouterMap[0])
        this.$router.push({ path: '/index' })
        sidemenu[0].classList.add('teacher')
        content[0].classList.add('teacher')
        sidemenu[0].classList.remove('admin')
        content[0].classList.remove('admin')
      }
    },
    handleMediaQuery (val) {
      this.query = val
      if (this.isMobile && !val['screen-xs']) {
        this.isMobile = false
        return
      }
      if (!this.isMobile && val['screen-xs']) {
        this.isMobile = true
        this.collapsed = false
        this.settings.contentWidth = false
        // this.settings.fixSiderbar = false
      }
    },
    handleCollapse (val) {
      this.collapsed = val
    },
    handleSettingChange ({ type, value }) {
      console.log('type', type, value)
      type && (this.settings[type] = value)
      switch (type) {
        case 'contentWidth':
          this.settings[type] = value === 'Fixed'
          break
        case 'layout':
          if (value === 'sidemenu') {
            this.settings.contentWidth = false
          } else {
            this.settings.fixSiderbar = false
            this.settings.contentWidth = true
          }
          break
      }
    }
  }
}
</script>

<style lang="less">
@import "./BasicLayout.less";
</style>
